var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrowdvotingFoerdersummenVisualisierungInlineRgb = function SvgCrowdvotingFoerdersummenVisualisierungInlineRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 340,
    height: 230,
    viewBox: "0 0 340 230",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 37.23,
    y: 169.6,
    width: 133.33,
    height: 43.67,
    rx: 2.7,
    ry: 2.7,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.88,186.39l2.89-2.63c1.27-1.15,1.76-1.79,1.76-2.66s-.67-1.38-1.69-1.38c-1.08,0-1.91.46-2.66,1.12v-2.08c.72-.56,1.69-.94,2.87-.94,1.81,0,3.49,1.14,3.49,3.01,0,1.41-.56,2.32-2.08,3.71l-1.69,1.55h4.1v1.77h-7v-1.48h.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.17,187.36v-1.9c.62.39,1.53.79,2.71.79s2.18-.53,2.18-1.64c0-.96-.82-1.63-2.19-1.63-.8,0-1.56.14-2.36.42l.65-5.37h5.26v1.74h-3.77l-.21,1.67c.27-.06.6-.1.94-.1,2.14,0,3.71,1.29,3.71,3.26,0,2.23-1.9,3.46-4.12,3.46-1.24,0-2.11-.31-2.8-.7Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,182.95c0-2.67,1.53-5.12,4.24-5.12s4.23,2.45,4.23,5.12-1.53,5.12-4.23,5.12-4.24-2.45-4.24-5.12ZM98.92,182.95c0-1.71-.8-3.22-2.21-3.22s-2.22,1.5-2.22,3.22.82,3.22,2.22,3.22,2.21-1.5,2.21-3.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.76,182.82l1.42-1.97h2.19l-2.46,3.34,2.67,3.67h-2.22l-1.63-2.25-1.64,2.25h-2.19l2.68-3.65-2.45-3.36h2.22s1.41,1.97,1.41,1.97Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.31,186.39l2.9-2.63c1.26-1.15,1.76-1.79,1.76-2.66s-.67-1.38-1.69-1.38c-1.08,0-1.91.46-2.66,1.12v-2.08c.72-.56,1.69-.94,2.87-.94,1.81,0,3.49,1.14,3.49,3.01,0,1.41-.56,2.32-2.08,3.71l-1.69,1.55h4.1v1.77h-7v-1.48h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.01,182.34c-.01.16-.03.34-.03.51,0,.2.01.32.03.44h3.02v1.22h-2.75c.41,1.1,1.39,1.7,2.68,1.7.97,0,1.67-.29,2.22-.72v1.98c-.67.41-1.54.59-2.47.59-2.42,0-4.06-1.48-4.6-3.55h-1.15v-1.22h.97c-.01-.17-.01-.32-.01-.46,0-.17.01-.32.03-.48h-.98v-1.21h1.22c.59-1.93,2.22-3.3,4.53-3.3.9,0,1.66.2,2.26.52v1.91c-.56-.34-1.18-.58-2.01-.58-1.18,0-2.12.49-2.59,1.45h2.66v1.21h-3.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.82,201.8v1.45c-.24.18-.69.3-1.07.3-.72,0-1.32-.28-1.59-.9-.48.49-1.25.96-2.42.96-1.5,0-2.59-.91-2.59-2.35,0-1.59,1.39-2.3,2.77-2.3.96,0,1.56.2,2.02.44v-.21c0-1.14-.96-1.32-1.86-1.32-.7,0-1.57.27-2.12.59v-1.66c.51-.27,1.31-.56,2.6-.56,1.95,0,3.34.98,3.34,2.75v2.38c0,.37.21.53.49.53.13,0,.28,0,.41-.08l.02-.02ZM51.95,200.65c-.38-.25-.9-.41-1.46-.41-.81,0-1.38.31-1.38.91,0,.65.56.91,1.25.91s1.26-.29,1.59-.72v-.7h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,202.56v.86h-1.98v-9.84h1.98v3.68c.39-.51,1.12-1.04,2.3-1.04,1.94,0,3.3,1.63,3.3,3.68s-1.36,3.7-3.3,3.7c-1.18,0-1.91-.52-2.3-1.04ZM61.81,199.9c0-1.1-.79-1.95-1.9-1.95-.81,0-1.45.49-1.74,1.04v1.83c.29.56.93,1.05,1.74,1.05,1.11,0,1.9-.86,1.9-1.97Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.36,201.94l2.89-2.63c1.27-1.15,1.76-1.79,1.76-2.66s-.67-1.38-1.69-1.38c-1.08,0-1.91.46-2.66,1.12v-2.08c.72-.56,1.69-.94,2.87-.94,1.81,0,3.49,1.14,3.49,3.01,0,1.41-.56,2.32-2.08,3.71l-1.69,1.55h4.1v1.77h-7v-1.48h.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.64,202.91v-1.9c.62.39,1.53.79,2.71.79s2.18-.53,2.18-1.64c0-.96-.82-1.63-2.19-1.63-.8,0-1.56.14-2.36.42l.65-5.37h5.26v1.74h-3.77l-.21,1.67c.27-.06.6-.1.94-.1,2.14,0,3.71,1.29,3.71,3.26,0,2.23-1.9,3.46-4.12,3.46-1.24,0-2.11-.31-2.8-.7Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.94,198.5c0-2.67,1.53-5.12,4.24-5.12s4.23,2.45,4.23,5.12-1.53,5.12-4.23,5.12-4.24-2.44-4.24-5.12ZM91.39,198.5c0-1.71-.8-3.22-2.21-3.22s-2.22,1.5-2.22,3.22.82,3.22,2.22,3.22,2.21-1.5,2.21-3.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,202.56v-2.11c.77.69,2.29,1.31,3.65,1.31.98,0,1.9-.35,1.9-1.14,0-.86-.93-1.03-2.19-1.42-1.7-.53-3.29-1-3.29-3.01,0-1.76,1.43-2.81,3.71-2.81,1.32,0,2.42.38,3.22.82v1.97c-.8-.49-2.02-.93-3.19-.93s-1.67.42-1.67.97c0,.73,1.05.86,2.39,1.28,1.59.52,3.12,1.21,3.12,3.08s-1.71,3.05-3.91,3.05c-1.43,0-2.77-.38-3.74-1.05h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.02,198.06h-1.38v-1.66h1.38v-1.92h1.98v1.92h2v1.66h-2v2.78c0,.7.29.98.96.98.38,0,.72-.1,1.03-.25v1.64c-.38.24-1.08.38-1.67.38-1.59,0-2.29-.9-2.29-2.36v-3.18h-.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.46,194.55c0-.67.52-1.2,1.18-1.2s1.18.52,1.18,1.2-.52,1.18-1.18,1.18-1.18-.52-1.18-1.18ZM113.66,196.4h1.98v7.01h-1.98v-7.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.67,196.4h1.98v.86c.42-.56,1.15-1.04,2.14-1.04,1.11,0,1.9.59,2.18,1.19.45-.65,1.35-1.19,2.42-1.19,1.45,0,2.5.91,2.5,2.81v4.38h-1.98v-3.93c0-1.25-.67-1.45-1.17-1.45-.62,0-1.21.44-1.46.96v4.43h-1.98v-3.93c0-1.24-.67-1.45-1.17-1.45-.6,0-1.21.42-1.48.93v4.46h-1.98v-7.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68,196.4h1.98v.86c.42-.56,1.15-1.04,2.14-1.04,1.11,0,1.9.59,2.18,1.19.45-.65,1.35-1.19,2.42-1.19,1.45,0,2.5.91,2.5,2.81v4.38h-1.98v-3.93c0-1.25-.67-1.45-1.17-1.45-.62,0-1.21.44-1.46.96v4.43h-1.98v-3.93c0-1.24-.67-1.45-1.17-1.45-.6,0-1.21.42-1.48.93v4.46h-1.98v-7.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,199.9c0-2.04,1.43-3.68,3.65-3.68s3.34,1.71,3.34,3.71v.52h-5.03c.21,1,1.15,1.46,2.35,1.46.84,0,1.62-.25,2.25-.62v1.59c-.58.44-1.59.72-2.67.72-2.12,0-3.89-1.41-3.89-3.7h0ZM148.27,199.18c-.03-.73-.56-1.41-1.48-1.41s-1.52.6-1.6,1.41h3.08Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.74,203.42v-7.01h1.98v.84c.49-.53,1.24-1.03,2.35-1.03,1.64,0,2.56,1.12,2.56,2.89v4.3h-1.98v-3.89c0-1.21-.73-1.49-1.34-1.49-.65,0-1.26.42-1.59.91v4.47h-1.98Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.46,60.7c-16.4,0-29.75,13.35-29.75,29.75s13.35,29.75,29.75,29.75,29.75-13.35,29.75-29.75-13.35-29.75-29.75-29.75ZM87.41,104.7c-1.81,1.88-3.87,3.37-6.13,4.42-2.28,1.06-4.92,1.6-7.86,1.6h-.02c-2.83,0-5.44-.52-7.76-1.56s-4.36-2.51-6.06-4.35c-1.7-1.85-3.02-4.03-3.92-6.48-.04-.11-.07-.22-.11-.33h-4.91v-5.59h3.75c-.06-.69-.09-1.32-.09-1.93,0-.65.03-1.31.1-2.04h-3.76v-5.54h4.91c.03-.11.07-.22.11-.33.9-2.45,2.21-4.62,3.9-6.45,1.68-1.83,3.72-3.29,6.07-4.33s4.97-1.57,7.79-1.57,5.54.54,7.73,1.61c2.17,1.05,4.17,2.5,5.96,4.3l.53.53-4.65,4.65-.52-.62c-1.13-1.34-2.46-2.37-3.96-3.09-1.49-.71-3.28-1.08-5.31-1.08-2.46,0-4.64.6-6.45,1.77-1.74,1.12-3.12,2.67-4.11,4.61h15.79l-1.8,5.54h-15.54c-.07.67-.1,1.36-.1,2.04,0,.64.03,1.29.1,1.93h15.11l-1.79,5.59h-11.75c1,1.97,2.41,3.53,4.2,4.66,1.86,1.18,4.08,1.77,6.63,1.77,2.02,0,3.81-.37,5.3-1.1,1.5-.73,2.84-1.78,3.97-3.12l.52-.61,4.65,4.58-.51.53h-.01Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.93,
    cy: 29.71,
    rx: 28.88,
    ry: 8.06,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.81,39.76c0-.49-.33-1.06-.97-1.67-6.61,3.5-17.29,5.3-27.9,5.3s-21.3-1.8-27.9-5.3c-.61.58-.93,1.12-.96,1.6v.15c.18,2.76,10.35,7.99,28.87,7.99s28.88-5.33,28.88-8.06h-.02Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.42,29.71c0-8.98-17.35-13.68-34.49-13.68s-34.49,4.69-34.49,13.68v.16h0v21.33c1.32-.13,2.66-.2,4.01-.2.54,0,1.07.02,1.6.04.18,0,.36,0,.54.02-.34-.41-.52-.8-.54-1.15v-.15c.03-.47.36-1.02.97-1.6,6.61,3.5,17.29,5.3,27.9,5.3s21.29-1.8,27.9-5.3c.64.61.98,1.19.98,1.68,0,2.74-10.19,8.06-28.88,8.06-3.19,0-6.13-.16-8.82-.43,2.62,1.72,5.02,3.75,7.16,6.03.55,0,1.11.02,1.66.02,10.61,0,21.29-1.8,27.9-5.3.64.61.98,1.19.98,1.68,0,2.64-9.5,7.69-26.95,8.04,1.21,1.74,2.29,3.57,3.21,5.49,8.82-.49,17.22-2.22,22.76-5.16.64.61.98,1.19.98,1.68,0,2.38-7.7,6.71-21.98,7.8.61,1.78,1.09,3.61,1.44,5.5,7.63-.69,14.7-2.35,19.57-4.93.64.61.98,1.19.98,1.68,0,2.27-6.99,6.3-19.99,7.63.07.94.11,1.89.11,2.84s-.04,1.86-.11,2.78c7.42-.72,14.27-2.36,19.01-4.87.64.61.97,1.18.97,1.67,0,2.3-7.19,6.42-20.55,7.68-.37,1.97-.88,3.9-1.53,5.75,8.09-.59,15.69-2.25,20.88-4.93,4.2-2.17,6.82-5.01,6.82-8.49V29.87h0v-.16ZM102.93,21.65c18.68,0,28.88,5.33,28.88,8.06s-10.19,8.06-28.88,8.06-28.88-5.33-28.88-8.06,10.19-8.06,28.88-8.06ZM102.93,47.82c-18.52,0-28.69-5.23-28.87-7.99v-.15c.03-.47.35-1.02.96-1.6,6.61,3.5,17.29,5.3,27.9,5.3s21.3-1.8,27.9-5.3c.64.61.97,1.18.97,1.67,0,2.74-10.19,8.06-28.88,8.06h.02Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.46,55.09c-19.5,0-35.36,15.86-35.36,35.36s15.86,35.36,35.36,35.36,35.36-15.86,35.36-35.36-15.86-35.36-35.36-35.36ZM72.46,120.2c-16.4,0-29.75-13.35-29.75-29.75s13.35-29.75,29.75-29.75,29.75,13.35,29.75,29.75-13.35,29.75-29.75,29.75Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75,100.21c-1.13,1.34-2.46,2.39-3.97,3.12-1.49.73-3.28,1.1-5.3,1.1-2.55,0-4.77-.59-6.63-1.77-1.78-1.13-3.19-2.7-4.2-4.66h11.75l1.79-5.59h-15.11c-.07-.65-.1-1.29-.1-1.93,0-.68.03-1.37.1-2.04h15.54l1.8-5.54h-15.79c.99-1.94,2.36-3.49,4.11-4.61,1.82-1.17,3.99-1.77,6.45-1.77,2.02,0,3.82.36,5.31,1.08,1.49.71,2.83,1.75,3.96,3.09l.52.62,4.65-4.65-.53-.53c-1.79-1.8-3.8-3.24-5.96-4.3-2.19-1.07-4.91-1.61-7.73-1.61s-5.44.53-7.79,1.57-4.39,2.5-6.07,4.33-2.99,4.01-3.9,6.45c-.03.11-.07.22-.11.33h-4.91v5.54h3.76c-.07.73-.1,1.39-.1,2.04s.03,1.24.09,1.93h-3.75v5.59h4.91c.03.11.07.22.11.33.9,2.45,2.22,4.63,3.92,6.48,1.7,1.85,3.74,3.32,6.06,4.35,2.32,1.03,4.94,1.57,7.76,1.57h.02c2.94,0,5.57-.55,7.86-1.61,2.26-1.05,4.32-2.54,6.13-4.42l.51-.53-4.65-4.58-.52.61h.01Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.69,
    y: 143.44,
    width: 327.88,
    height: 2.44,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.36,
    y: 125.97,
    width: 2.44,
    height: 25.49,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.86,
    y: 141.16,
    width: 2.44,
    height: 6.53,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.36,
    y: 141.16,
    width: 2.44,
    height: 6.53,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.87,
    y: 141.16,
    width: 2.44,
    height: 6.53,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.54,
    y: 125.97,
    width: 2.44,
    height: 25.49,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.37,
    y: 141.16,
    width: 2.44,
    height: 6.53,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.87,
    y: 141.16,
    width: 2.44,
    height: 6.53,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.36,
    y: 140.72,
    width: 2.44,
    height: 7.89,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.56 180.36 170.56 157.25 153.31 174.5 170.56 180.36",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.79,
    y: 169.6,
    width: 133.33,
    height: 43.67,
    rx: 2.7,
    ry: 2.7,
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.72,187.36v-1.9c.62.39,1.53.79,2.71.79s2.18-.53,2.18-1.64c0-.96-.82-1.63-2.19-1.63-.8,0-1.56.14-2.36.42l.65-5.37h5.26v1.74h-3.77l-.21,1.67c.27-.06.6-.1.94-.1,2.14,0,3.71,1.29,3.71,3.26,0,2.23-1.9,3.46-4.12,3.46-1.24,0-2.11-.31-2.8-.7h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.02,182.95c0-2.67,1.53-5.12,4.24-5.12s4.23,2.45,4.23,5.12-1.53,5.12-4.23,5.12-4.24-2.45-4.24-5.12ZM253.47,182.95c0-1.71-.8-3.22-2.21-3.22s-2.22,1.5-2.22,3.22.82,3.22,2.22,3.22,2.21-1.5,2.21-3.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,182.95c0-2.67,1.53-5.12,4.24-5.12s4.23,2.45,4.23,5.12-1.53,5.12-4.23,5.12-4.24-2.45-4.24-5.12ZM263.37,182.95c0-1.71-.8-3.22-2.21-3.22s-2.22,1.5-2.22,3.22.82,3.22,2.22,3.22,2.21-1.5,2.21-3.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.21,182.82l1.42-1.97h2.19l-2.46,3.34,2.67,3.67h-2.22l-1.63-2.25-1.64,2.25h-2.19l2.68-3.65-2.45-3.36h2.22l1.41,1.97Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.76,186.39l2.9-2.63c1.26-1.15,1.76-1.79,1.76-2.66s-.67-1.38-1.69-1.38c-1.08,0-1.91.46-2.66,1.12v-2.08c.72-.56,1.69-.94,2.87-.94,1.81,0,3.49,1.14,3.49,3.01,0,1.41-.56,2.32-2.08,3.71l-1.69,1.55h4.1v1.77h-7v-1.48h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.45,182.34c-.01.16-.03.34-.03.51,0,.2.01.32.03.44h3.02v1.22h-2.75c.41,1.1,1.39,1.7,2.68,1.7.97,0,1.67-.29,2.22-.72v1.98c-.67.41-1.55.59-2.47.59-2.42,0-4.06-1.48-4.6-3.55h-1.15v-1.22h.97c-.01-.17-.01-.32-.01-.46,0-.17.01-.32.03-.48h-.98v-1.21h1.22c.59-1.93,2.22-3.3,4.53-3.3.9,0,1.66.2,2.26.52v1.91c-.56-.34-1.18-.58-2.01-.58-1.18,0-2.12.49-2.59,1.45h2.66v1.21h-3.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.48,201.8v1.45c-.24.18-.69.3-1.07.3-.72,0-1.32-.28-1.59-.9-.48.49-1.25.96-2.42.96-1.5,0-2.59-.91-2.59-2.35,0-1.59,1.39-2.3,2.77-2.3.96,0,1.56.2,2.02.44v-.21c0-1.14-.96-1.32-1.85-1.32-.7,0-1.57.27-2.12.59v-1.66c.51-.27,1.31-.56,2.6-.56,1.95,0,3.34.98,3.34,2.75v2.38c0,.37.21.53.49.53.13,0,.28,0,.41-.08v-.02ZM214.61,200.65c-.38-.25-.9-.41-1.46-.41-.82,0-1.38.31-1.38.91,0,.65.56.91,1.25.91s1.26-.29,1.59-.72v-.7h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.83,202.56v.86h-1.98v-9.84h1.98v3.68c.39-.51,1.12-1.04,2.3-1.04,1.94,0,3.3,1.63,3.3,3.68s-1.36,3.7-3.3,3.7c-1.18,0-1.91-.52-2.3-1.04ZM224.47,199.9c0-1.1-.79-1.95-1.9-1.95-.82,0-1.45.49-1.74,1.04v1.83c.29.56.93,1.05,1.74,1.05,1.11,0,1.9-.86,1.9-1.97Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.19,202.91v-1.9c.62.39,1.53.79,2.71.79s2.18-.53,2.18-1.64c0-.96-.82-1.63-2.19-1.63-.8,0-1.56.14-2.36.42l.65-5.37h5.26v1.74h-3.77l-.21,1.67c.27-.06.6-.1.94-.1,2.14,0,3.71,1.29,3.71,3.26,0,2.23-1.9,3.46-4.12,3.46-1.24,0-2.11-.31-2.8-.7h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.49,198.5c0-2.67,1.53-5.12,4.24-5.12s4.23,2.45,4.23,5.12-1.53,5.12-4.23,5.12-4.24-2.44-4.24-5.12ZM245.94,198.5c0-1.71-.8-3.22-2.21-3.22s-2.22,1.5-2.22,3.22.82,3.22,2.22,3.22,2.21-1.5,2.21-3.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39,198.5c0-2.67,1.53-5.12,4.24-5.12s4.23,2.45,4.23,5.12-1.53,5.12-4.23,5.12-4.24-2.44-4.24-5.12h0ZM255.84,198.5c0-1.71-.8-3.22-2.21-3.22s-2.22,1.5-2.22,3.22.82,3.22,2.22,3.22,2.21-1.5,2.21-3.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,202.56v-2.11c.77.69,2.29,1.31,3.65,1.31.98,0,1.9-.35,1.9-1.14,0-.86-.93-1.03-2.19-1.42-1.7-.53-3.29-1-3.29-3.01,0-1.76,1.43-2.81,3.71-2.81,1.32,0,2.42.38,3.22.82v1.97c-.8-.49-2.02-.93-3.19-.93s-1.67.42-1.67.97c0,.73,1.05.86,2.39,1.28,1.59.52,3.12,1.21,3.12,3.08s-1.71,3.05-3.91,3.05c-1.43,0-2.77-.38-3.74-1.05h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.47,198.06h-1.38v-1.66h1.38v-1.92h1.98v1.92h2v1.66h-2v2.78c0,.7.29.98.96.98.38,0,.72-.1,1.03-.25v1.64c-.38.24-1.08.38-1.67.38-1.59,0-2.29-.9-2.29-2.36v-3.18h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.91,194.55c0-.67.52-1.2,1.18-1.2s1.18.52,1.18,1.2-.52,1.18-1.18,1.18-1.18-.52-1.18-1.18ZM278.11,196.4h1.98v7.01h-1.98v-7.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.12,196.4h1.98v.86c.42-.56,1.15-1.04,2.14-1.04,1.11,0,1.9.59,2.18,1.19.45-.65,1.35-1.19,2.42-1.19,1.45,0,2.5.91,2.5,2.81v4.38h-1.98v-3.93c0-1.25-.67-1.45-1.17-1.45-.62,0-1.21.44-1.46.96v4.43h-1.98v-3.93c0-1.24-.67-1.45-1.17-1.45-.6,0-1.21.42-1.48.93v4.46h-1.98v-7.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.13,196.4h1.98v.86c.42-.56,1.15-1.04,2.14-1.04,1.11,0,1.9.59,2.18,1.19.45-.65,1.35-1.19,2.42-1.19,1.45,0,2.5.91,2.5,2.81v4.38h-1.98v-3.93c0-1.25-.67-1.45-1.17-1.45-.62,0-1.21.44-1.46.96v4.43h-1.98v-3.93c0-1.24-.67-1.45-1.17-1.45-.6,0-1.21.42-1.48.93v4.46h-1.98v-7.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.67,199.9c0-2.04,1.43-3.68,3.65-3.68s3.34,1.71,3.34,3.71v.52h-5.03c.21,1,1.15,1.46,2.35,1.46.84,0,1.62-.25,2.25-.62v1.59c-.58.44-1.59.72-2.67.72-2.12,0-3.89-1.41-3.89-3.7h0ZM312.72,199.18c-.03-.73-.56-1.41-1.48-1.41s-1.52.6-1.6,1.41h3.08Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.18,203.42v-7.01h1.98v.84c.49-.53,1.24-1.03,2.35-1.03,1.64,0,2.56,1.12,2.56,2.89v4.3h-1.98v-3.89c0-1.21-.73-1.49-1.33-1.49-.65,0-1.26.42-1.59.91v4.47h-1.99Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.11 180.36 334.11 157.25 316.87 174.5 334.11 180.36",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.96,54.7h-8.83v-23.59h8.83c3.82,0,6.93,1.1,9.33,3.3,2.4,2.2,3.61,5.03,3.61,8.49s-1.2,6.32-3.61,8.53c-2.38,2.18-5.49,3.27-9.33,3.27ZM175.99,35.46v14.9h3.57c2.63,0,4.68-.66,6.15-1.97s2.21-3.14,2.21-5.48-.74-4.16-2.21-5.48c-1.47-1.31-3.52-1.97-6.15-1.97h-3.57Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.9,46.28c0-2.49.88-4.58,2.63-6.27,1.73-1.71,3.96-2.56,6.71-2.56s4.98.85,6.71,2.56c1.75,1.71,2.63,3.8,2.63,6.27s-.88,4.63-2.63,6.34c-1.75,1.69-3.99,2.53-6.71,2.53s-4.95-.84-6.71-2.53c-1.75-1.71-2.63-3.82-2.63-6.34ZM200.59,46.28c0,1.35.44,2.47,1.31,3.37.88.9,1.99,1.35,3.34,1.35s2.46-.45,3.34-1.35c.88-.92,1.31-2.04,1.31-3.37s-.44-2.46-1.31-3.34c-.88-.9-1.99-1.35-3.34-1.35s-2.46.45-3.34,1.35c-.88.88-1.31,1.99-1.31,3.34Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.36,37.45c2.29,0,4.18.85,5.66,2.56,1.5,1.66,2.26,3.76,2.26,6.3s-.75,4.59-2.26,6.3c-1.48,1.69-3.37,2.53-5.66,2.53s-4.2-.83-5.53-2.49v8.8h-4.75v-23.56h4.75v2.06c1.26-1.66,3.1-2.49,5.53-2.49ZM227.01,41.6c-.9,0-1.72.24-2.46.71-.74.47-1.31,1.08-1.72,1.82v4.38c.4.74.98,1.34,1.72,1.8.74.46,1.56.69,2.46.69,1.35,0,2.44-.45,3.27-1.35.85-.92,1.28-2.03,1.28-3.34s-.43-2.45-1.28-3.37c-.83-.9-1.92-1.35-3.27-1.35Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06,37.45c2.29,0,4.18.85,5.66,2.56,1.5,1.66,2.26,3.76,2.26,6.3s-.75,4.59-2.26,6.3c-1.48,1.69-3.37,2.53-5.66,2.53s-4.2-.83-5.53-2.49v8.8h-4.75v-23.56h4.75v2.06c1.26-1.66,3.1-2.49,5.53-2.49ZM248.71,41.6c-.9,0-1.72.24-2.46.71-.74.47-1.31,1.08-1.72,1.82v4.38c.4.74.98,1.34,1.72,1.8.74.46,1.56.69,2.46.69,1.35,0,2.44-.45,3.27-1.35.85-.92,1.28-2.03,1.28-3.34s-.43-2.45-1.28-3.37c-.83-.9-1.92-1.35-3.27-1.35Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.71,55.14c-2.63,0-4.84-.81-6.64-2.43-1.8-1.62-2.7-3.76-2.7-6.44,0-2.49.81-4.58,2.43-6.27,1.62-1.71,3.73-2.56,6.34-2.56,2.43,0,4.37.87,5.83,2.59,1.46,1.73,2.19,3.83,2.19,6.3v1.25h-12.06c.25,1.12.87,1.99,1.87,2.6,1,.61,2.25.91,3.76.91,1.86,0,3.66-.49,5.39-1.48v3.81c-1.51,1.15-3.64,1.72-6.4,1.72ZM265.09,44.56h7.38c-.04-.97-.39-1.77-1.03-2.41-.64-.64-1.48-.96-2.51-.96s-1.93.31-2.63.93c-.7.62-1.1,1.43-1.21,2.44Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.28,55.14c-1.39,0-2.49-.38-3.29-1.13s-1.2-1.93-1.2-3.52v-19.38h4.75v18.13c0,1.12.5,1.69,1.52,1.69.47,0,.88-.1,1.21-.3v3.91c-.81.4-1.81.61-3,.61Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.56,49.48v-7.62h-3.3v-3.98h3.3v-4.62h4.75v4.62h4.79v3.98h-4.79v6.67c0,.83.18,1.43.54,1.8s.94.56,1.75.56,1.65-.2,2.46-.61v3.94c-.99.61-2.33.91-4.01.91-3.66,0-5.49-1.89-5.49-5.66Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.06,55.14c-2.63,0-4.84-.81-6.64-2.43-1.8-1.62-2.7-3.76-2.7-6.44,0-2.49.81-4.58,2.43-6.27,1.62-1.71,3.73-2.56,6.34-2.56,2.43,0,4.37.87,5.83,2.59,1.46,1.73,2.19,3.83,2.19,6.3v1.25h-12.06c.25,1.12.87,1.99,1.87,2.6,1,.61,2.25.91,3.76.91,1.86,0,3.66-.49,5.39-1.48v3.81c-1.51,1.15-3.64,1.72-6.4,1.72ZM309.44,44.56h7.38c-.04-.97-.39-1.77-1.03-2.41-.64-.64-1.48-.96-2.51-.96s-1.93.31-2.63.93c-.7.62-1.1,1.43-1.21,2.44Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.37,91.33h-2.49v-23.59h16.08v2.26h-13.58v7.85h11.02v2.26h-11.02v11.22Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.96,77.18c1.64-1.69,3.75-2.53,6.33-2.53s4.7.84,6.34,2.53c1.64,1.64,2.46,3.65,2.46,6.03s-.82,4.39-2.46,6.03c-1.66,1.66-3.77,2.49-6.34,2.49s-4.67-.83-6.33-2.49c-1.64-1.64-2.46-3.65-2.46-6.03s.82-4.39,2.46-6.03ZM204.6,83.21c0-1.8-.59-3.31-1.79-4.55-1.19-1.21-2.7-1.82-4.52-1.82s-3.33.61-4.52,1.82c-1.19,1.24-1.79,2.75-1.79,4.55s.59,3.28,1.79,4.52c1.19,1.21,2.7,1.82,4.52,1.82s3.33-.61,4.52-1.82c1.19-1.24,1.79-2.74,1.79-4.52ZM193.82,70.71c-.29-.31-.44-.7-.44-1.15s.15-.82.44-1.11c.31-.31.7-.47,1.15-.47s.82.16,1.11.47c.31.29.47.66.47,1.11s-.16.83-.47,1.15c-.29.29-.66.44-1.11.44s-.83-.15-1.15-.44ZM200.55,70.71c-.29-.31-.44-.7-.44-1.15s.15-.82.44-1.11c.31-.31.7-.47,1.15-.47s.82.16,1.11.47c.31.29.47.66.47,1.11s-.16.83-.47,1.15c-.29.29-.66.44-1.11.44s-.83-.15-1.15-.44Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.04,91.33h-2.43v-16.28h2.43v3.1c.61-1.06,1.5-1.9,2.7-2.54,1.19-.64,2.45-.96,3.77-.96v2.46c-.74,0-1.42.1-2.02.3-1.03.27-1.94.74-2.73,1.4-.79.66-1.36,1.41-1.72,2.24v10.28Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.35,77.65v-9.91h2.43v23.59h-2.43v-2.59c-1.53,2-3.63,3-6.3,3-2.4,0-4.37-.83-5.9-2.49-1.53-1.66-2.29-3.67-2.29-6.03s.76-4.4,2.29-6.07c1.53-1.66,3.49-2.49,5.9-2.49,2.67,0,4.77,1,6.3,3ZM237.35,85.88v-5.36c-.47-1.08-1.24-1.96-2.29-2.65-1.06-.69-2.2-1.03-3.44-1.03-1.82,0-3.31.62-4.48,1.85-1.19,1.24-1.79,2.74-1.79,4.52s.59,3.28,1.79,4.52c1.19,1.21,2.68,1.82,4.48,1.82,1.21,0,2.35-.34,3.4-1.03,1.06-.69,1.83-1.57,2.33-2.65Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29,91.74c-2.54,0-4.67-.8-6.4-2.39-1.71-1.57-2.56-3.62-2.56-6.13s.76-4.46,2.29-6.1c1.55-1.64,3.54-2.46,5.96-2.46,1.3,0,2.46.26,3.47.79,1.01.53,1.81,1.22,2.39,2.07.58.85,1.02,1.76,1.31,2.71.29.96.44,1.92.44,2.88v.67h-13.38c.13,1.75.84,3.15,2.11,4.2,1.27,1.04,2.88,1.57,4.84,1.57s3.63-.51,5.22-1.52v2.16c-1.33,1.03-3.22,1.55-5.7,1.55ZM246.86,81.8h10.88c-.07-1.26-.54-2.39-1.42-3.4-.83-1.03-2.11-1.55-3.84-1.55-1.62,0-2.94.49-3.98,1.48-1.01,1.01-1.56,2.17-1.65,3.47Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.18,91.33h-2.43v-16.28h2.43v3.1c.61-1.06,1.5-1.9,2.7-2.54,1.19-.64,2.45-.96,3.77-.96v2.46c-.74,0-1.42.1-2.02.3-1.03.27-1.94.74-2.73,1.4-.79.66-1.36,1.41-1.72,2.24v10.28Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.62,86.04v-10.99h2.43v16.28h-2.43v-2.49c-1.73,1.93-3.9,2.9-6.5,2.9-2,0-3.53-.59-4.6-1.77-1.07-1.18-1.6-2.85-1.6-5v-9.91h2.43v9.37c0,3.35,1.54,5.02,4.62,5.02,1.12,0,2.2-.34,3.23-1.01,1.1-.72,1.91-1.52,2.43-2.39Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.21,80.35v10.99h-2.43v-16.28h2.43v2.49c1.73-1.93,3.9-2.9,6.5-2.9,2,0,3.53.59,4.6,1.77,1.07,1.18,1.6,2.85,1.6,5v9.91h-2.43v-9.37c0-3.35-1.54-5.02-4.62-5.02-1.12,0-2.21.35-3.27,1.04-1.08.7-1.88,1.48-2.39,2.36Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.65,90.29v-1.72c-1.46,1.93-3.56,2.9-6.3,2.9-2.4,0-4.37-.81-5.9-2.43-1.53-1.66-2.29-3.65-2.29-5.96s.76-4.3,2.29-5.96c1.5-1.64,3.47-2.46,5.9-2.46,2.79,0,4.89.97,6.3,2.9v-2.49h2.43v15.23c0,2.56-.84,4.52-2.53,5.86-1.64,1.37-3.74,2.06-6.3,2.06s-4.57-.49-6.3-1.48v-2.36c1.84,1.1,3.86,1.65,6.07,1.65,2.02,0,3.63-.48,4.84-1.45,1.2-.97,1.8-2.39,1.8-4.28ZM331.65,85.71v-5.29c-.45-1.06-1.2-1.92-2.26-2.58-1.06-.66-2.21-.99-3.47-.99-1.8,0-3.29.6-4.48,1.79s-1.79,2.67-1.79,4.45.59,3.26,1.79,4.45c1.17,1.17,2.66,1.75,4.48,1.75,1.26,0,2.42-.33,3.47-.99,1.06-.66,1.81-1.52,2.26-2.58Z",
    style: {
      fill: "#b40055",
      strokeWidth: 0
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrowdvotingFoerdersummenVisualisierungInlineRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crowdvoting-foerdersummen-visualisierung-inline-rgb.55b4be03f31c9e319c60ff7abd5639f4.svg";